export default __webpack_public_path__ + "static/media/page8Image1.242dcce5.jpeg";